<template>
  <div class="news">
    <!-- <div class="xwgg">
      <div>新闻公告</div>
    </div> -->
    <div class="xwgg-con">
      <div>
        <div class="title xwggtext"></div>

        <div class="newscontent" v-for="item in newsList" :key="item.id"
             @click="goDetail(item.id)">
          <div class="time">{{item.formatTime}}</div>
          <div class="content">{{item.title}}</div>
        </div>
      </div>
    </div>
    <pagination :currentPage="currentPage" :pageCount="pageCount" @goPrePage="goPrePage" @goNextPage="goNextPage"></pagination>
  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  import pagination from './common/pagination'

  export default {
    components: {
      pagination
    },
    data() {
      return {
        newsList: [],
        pageSize: 20,

        currentPage:1,
        pageCount:0//页数
      }
    },
    mounted() {
      this.getList(this.currentPage, this.pageSize)
    },
    methods: {
      goNextPage(index) {
        this.currentPage=index?index:this.currentPage+1
        this.getList(this.currentPage, this.pageSize)
      },
      goPrePage(index) {
        this.currentPage=index?index:this.currentPage-1
        this.getList(this.currentPage, this.pageSize)

      },
      async getList(index, size) {
        var data = await http.newslist(index, size)
        this.currentPage = data.data[0].pageIndex
        this.pageCount = data.data[0].total

        this.newsList = data.data[0].list
        for (var i = 0; i < this.newsList.length; i++) {
          this.newsList[i].formatTime = format.formatDate(this.newsList[i].createTime)
        }
      },
      goDetail(id) {
        var params = format.formatKeys(this.$route.query)
        // this.$router.push("/newsdetail?"+params+"newsId="+id)
        let routerUrl = this.$router.resolve({
          path:"/newsdetail?"+params+"newsId="+id,
        })
        window.open(routerUrl.href)
      }
    }
  }
</script>
<style scoped>
  .xwgg {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .xwgg div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .xwgg-con > div {
    padding: 35px 50px 30px 50px;
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;

  }

  .xwggtext {
    background-image: url("../assets/xwgg.png");
  }

  .newscontent {
    margin: 10px 0;
    background: #f5f5f5;
    height: 45px;
    line-height: 45px;
  }

  .newscontent > div {
    font-size: 16px;
    display: inline-block;
  }

  .newscontent .time {
    width: 120px;
    background: #e4f1fd;
    border-left: solid 2px #27a7ea;
    text-align: center;
  }

  .newscontent .content {
    padding-left: 10px;
  }

  .block {
    text-align: center;
  }
  .news {
    padding-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue